// tslint:disable:max-line-length
// tslint:disable:quotemark
// tslint:disable:semicolon
// tslint:disable:triple-equals
// tslint:disable:no-inferrable-types
import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, HostListener, OnDestroy, OnChanges } from '@angular/core';
import { MainService } from 'src/app/services/main-service.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
import { CommonModule, DatePipe } from '@angular/common';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
// import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { environment } from 'src/environments/environment';
// import { Socket } from 'ngx-socket-io';
import { Socket } from 'socket.io-client';
import { CustomDateAdapter } from 'src/app/shared/date-time/date-adapter.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { SignaturePadComponent } from 'src/app/shared/signature-pad/signature-pad.component';
import { CreditReportConfirmationComponent } from '../credit-report-confirmation/credit-report-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
// import { SignaturePadComponent } from 'src/app/shared/signature-pad/signature-pad.component';

// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'MM/DD/YYYY'
//   },
//   display: {
//     dateInput: 'MM/DD/YYYY',
//     monthYearLabel: "MMM YYYY",
//   }
// };

@Component({
  selector: 'app-pay-now',
  templateUrl: './pay-now.component.html',
  styleUrls: ['./pay-now.component.scss'],

  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    [
      CustomDateAdapter, // so we could inject services to 'CustomDateAdapter'
      { provide: DateAdapter, useClass: CustomDateAdapter }, // Parse MatDatePicker Format
    ]
  ]
})
export class PayNowComponent implements OnInit, OnDestroy, OnChanges {
  payment_step = 0;
  mod_step = 0;
  opened_step = 0;
  cardError: any;
  contractToken: any;
  bsConfig: Partial<BsDatepickerConfig>;
  planInfo: any;
  modalRef: BsModalRef;
  terms: any;
  check_business_terms: any;
  // signed: any;
  @ViewChild('addBankModal') public addBankModal: ModalDirective;
  @ViewChild('failModal') failModal: TemplateRef<any>;
  // @ViewChild(SignaturePadComponent) signaturePadComponent!: SignaturePadComponent;

  buttonClickedSubject: Subject<any> = new Subject();
  card_payment_tried = 0;
  paymentDetails: any = {
    cardName: '',
    stripeToken: '',
    recurringDate: ''
  };
  paymentLoader: boolean = false;
  animationStart: boolean = false;
  loadingZip: boolean = false;
  backUpCard: boolean = false;
  recurringCard: boolean = false;
  todayPaymentCard: boolean;
  zips: any[] = [];
  closure_html: any;
  closure_terms: any
  show_closure_form: any = 0;
  timezone: any;
  mask: any = [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  verified = 0;//0: cann't say, 1:verified, 2: approved
  urls = {
    customer_panel: 'https://demo.credee.com/customer/',
    customer_android_app: 'https://play.google.com/store/apps/details?id=com.bhct.credee.cust',
    customer_ios_app: 'https://apps.apple.com/us/app/credee-customer/id6445950493'
  };
  @ViewChild('paymentModal') paymentModal: ModalDirective;
  @ViewChild('tilaModal') tilaModal: ModalDirective;
  @ViewChild('hipaaModal') hipaaModal: ModalDirective;
  @ViewChild('addNewPaymentMethodModal') public addNewPaymentMethodModal: ModalDirective;
  @ViewChild('paymentFail') public paymentFail: ModalDirective;
  @ViewChild('dobdp') private _picker: BsDatepickerDirective;
  @ViewChild(SignaturePadComponent) signaturePadComponent!: SignaturePadComponent;

  dp_last4 = '';
  recurring_last4 = '';
  recurring_date = '';
  recurring_token = '';
  alternate_recurring_source_id = '';
  payment_error = '';
  patientData: any = {
    primary_sources: [],
    recurring_sources: [],
    backup_sources: [],
    plaid_access_token: ''
  };
  dp_source_id = 0;
  recurring_source_id = 0;
  backup_source_id = 0;
  selected_dp_card;
  selected_recurring_card;
  selected_backup_card;
  is_waived = 0;
  new_bank_added = 0;
  actual_matrix;
  success_message = "Your payment has been made successfully!\nPlease click on continue to finish your application."
  primary_card_added = 0;
  recurring_card_added = 0;
  backup_card_added = 0;
  signature: any;
  signatureUrl: any;
  date: Date = new Date();
  payment_source_type = '';
  public closeBtnHandle = false;
  public signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 587,
    'canvasHeight': 200
  };
  // @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild('canvasDiv', {static: true}) canvasDiv: ElementRef<any>;
  @ViewChild('canvasDiv1') canvasDiv1: ElementRef<any>;
  add_card_source_id;
  cards_array = [];
  is_mobile_screen = window.screen.width < 768;
  enrollment_fee: number;
  split_request_data: any;
  plans: any;
  patient_address: UntypedFormGroup = this.fb.group({}); zipPostalCode: any;
  add_bank_step = 'card';
  zipCode: any = '';
  selected_card: any = '';
  contract_service_record: any = [];
  contract_code = '';
  @ViewChild('confirmPaymentModal') public confirmPaymentModal: ModalDirective;
  add_button: boolean;
  flag_code = '';
  showSSNfields: boolean = true;
  mobile_pattern: any;
  bank_addded = false;
  language_data: any;
  contract_service_plan: any;
  showConfirmationDialog: boolean = false;
  patientSsn: any;
  stripeFieldsshow: boolean = false;
  payRecurring: any = {
    pay_recurring: 0,
    payToken: ''
  };
  showError = false;
  showMobError = false;
  errorMsg = 'Please enter a SSN';
  showvalidation: boolean;
  validValue: boolean = false;
  patientData_recure: any;
  patientData_backup: any;
  dataEnter: boolean = false;
  buttonSelectedType = {
    existing: 1,
    bank: 2,
    cardTab: 3
  }
  selectTypeButtonCardBank = '';
  charge_flow = 1;
  redirect_url = '';
  panel: string = "request";
  routeStep = false;
  scanner_continue = false;
  manual_continue = false;
  stepHeader: any;
  stepThree: any;
  enrollmentFee: string;
  showModalHipaa = false;
  showModalTila = false;
  from_mobile = false;
  showBankBtn: any;
  mobile_validation: any;
  phone_length: any;
  min_phone_length: any;
  creditReportOption = false;
  customerSelection = false;
  constructor(
    private el: ElementRef,
    public mainService: MainService,
    public route: ActivatedRoute,
    public router: Router,
    public proposal: ProposalService,
    public datePipe: DatePipe,
    public toaster: ToasterService,
    private modalService: BsModalService,
    public cd: ChangeDetectorRef,
    private dialog:MatDialog,
    // public plaidService: plaidService,
    private fb: UntypedFormBuilder, private _socket: Socket
  ) {
    this.patient_address = this.fb.group({
      patient_first_name: ['', Validators.required],
      patient_last_name: ['', Validators.required],
      patient_email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      patient_mobile: ['', Validators.required],
      patient_ssn: ['', Validators.required],
      city: [{value: '', disabled: true}, Validators.required],
      city_id: ['', Validators.required],
      state: ['', Validators.required],
      state_name: [{value: '', disabled: true}, Validators.required],
      state_code: [''],
      zip: [{value: '', disabled: true}, Validators.required],
      address: ['', Validators.required],
      address_2: [''],
      zipSelected: false,
      patient_mobile_country_code: [{value: '', disabled: true}],
      language_preffered: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.mainService.topHeader.subscribe((data) => {
      this.stepHeader = data;
      console.log(this.stepHeader);
    })
    this.payment_step = 0;
    this.mod_step = 0;
    this.route.params.subscribe((data: any) => {
      this.contractToken = data.token;
      this.proposal.setToken(this.contractToken);
      if (data.setup_intent || data.setup_intent_client_secret) {
        const params = {
          url: window.location.href
        };
        console.log(window.location.href);
        this.proposal.api('post', 'track_stripe_redirect', this.mainService.urlParams(params))
        .subscribe((d: any) => {
          // console.log(d);
        });
      }
    });

    this.bsConfig = Object.assign({}, {
      showWeekNumbers: false,
      containerClass: window.screen.width < 768 ? 'theme-mobile-blue' : 'theme-blue',
      dateInputFormat: 'MM/DD/YYYY',
      selectFromOtherMonth: true
    });
    this.mainService.subject
      .subscribe((data: any) => {
        this.ShowStripeElement();
      });
    if (this.mainService.data && this.mainService.data.is_error == 0) {
      this.ShowStripeElement();
    }

    if (this.opened_step != 0) {
      this.mainService.closePayBtn = true;
    }
    this.mainService.language_data$.subscribe(data => {
      if (data && data.length) {
        this.language_data = data;
        console.log(this.language_data);
      }
    })

    this.proposal.getData().subscribe(async (data: any) => {
      this.timezone = data?.timezone || data?.split_request_data?.[0]?.timezone || data?.result?.timezone || '+0000';
      if(data?.is_error == 0){
        this.showSSNfields = data.doctor_country_currency_info.SSN;
        this.mobile_pattern = data.doctor_country_currency_info.mobile_regex;
        this.phone_length = data?.doctor_country_currency_info?.phone_length || 12;
        this.min_phone_length = data?.doctor_country_currency_info?.min_phone_length || 7;
        this.updateMasking(data.doctor_country_currency_info['country']['country_phone_format']);
        this.contract_service_plan = data.split_request_data;
        if (this.contract_service_plan && this.contract_service_plan.length) {
          this.patient_address.patchValue({ language_preffered: this.contract_service_plan[0].language_preffered });
        }
        this.enrollmentFee = this.contract_service_plan[0].plans_array && this.contract_service_plan[0].plans_array[0] && JSON.stringify(this.contract_service_plan[0].plans_array[0].enrollment_fee && this.contract_service_plan[0].plans_array[0].enrollment_fee == 0) ? JSON.stringify(this.contract_service_plan[0].plans_array[0].enrollment_fee) : "30";
        if (data && data.patients && data.patients.length > 0) {
          this.patientData = data.patients[0];
          console.log(this.patientData);
          
          // this.patientData['patient_ssn'] = '';
          this.patientSsn = this.patientData.hasOwnProperty("patient_ssn") ? (this.patientData['patient_ssn'] == null ? '' : this.patientData['patient_ssn']) : '';

          if (this.patientData && this.patientData['plaid_access_token'] && this.patientData['bank_status'] == 'pending') {
            if (!this.patientData['payment_sources']) {
              this.patientData['payment_sources'] = [];
            }
            let pending_banks = this.patientData['payment_sources'].filter(source => source.source_id == -1)
            if (pending_banks.length == 0) {
              this.patientData['payment_sources'] = [...[{ payment_source_type: 1, last4: 'XXXX', source_id: -1 }], ...this.patientData['payment_sources']]
            }
          }
          if (this.patientData && this.patientData['payment_sources'] && this.patientData['payment_sources'].length > 0) {
            this.patientData['payment_sources'] = this.patientData['payment_sources'].sort(function (a, b) {
              return a.payment_source_type - b.payment_source_type;
            });
          }
          const bankList = this.patientData['payment_sources'].filter(item => item.payment_source_type == 1);
          if (bankList && bankList.length) {
            this.bank_addded = true;
          }
          this.checkNavigationData();
        }

        if (data && data.split_request_data && data.split_request_data.length) {
          this.split_request_data = data.split_request_data;
        }
        if (data) {

          if (this.split_request_data[0].is_ar_contract == 1 ? ((this.patientData['patient_first_name'] && this.patientData['patient_email']) || (this.split_request_data['patient_first_name'] && this.split_request_data['patient_email'])) : ((this.patientData && this.patientData['patient_first_name'] && this.patientData['patient_last_name'] && this.patientData['patient_address'] && this.patientData['patient_email']) || (this.split_request_data[0].patient_first_name && this.split_request_data[0].patient_last_name && this.split_request_data[0].patient_email))) {
            setTimeout(() => {
              this.patient_address.patchValue({
                patient_first_name: this.split_request_data[0].patient_first_name || this.patientData['patient_first_name'],
                patient_last_name: this.split_request_data[0].patient_last_name || this.patientData['patient_last_name'],
                patient_email: this.split_request_data[0].patient_email || this.patientData['patient_email'],
                patient_mobile: (this.split_request_data[0].patient_email.includes('+1-') || this.planInfo.apf_patient_mobile.includes('+1-')) ? (this.split_request_data[0].patient_email.split('-')[1] || this.planInfo.apf_patient_mobile.split('-')[1]) : this.planInfo.apf_patient_mobile || this.patientData['patient_mobile'],
                patient_ssn: this.patientData['patient_ssn'] && this.patientData['patient_ssn'].length > 0 ? (new Array(this.patientData['patient_ssn'].length - 4).fill('*').join('') + (this.patientData['patient_ssn'] + '').substring(this.patientData['patient_ssn'].length - 4, this.patientData['patient_ssn'].length)) : '',
                city: '',
                city_id: '',
                state: '',
                state_name: '',
                zip: '',
                address: ((this.split_request_data[0].patient_address || this.patientData.patient_address || '').split(' || ')[0]),
                address_2: ((this.split_request_data[0].patient_address || this.patientData.patient_address || '').split(' || ')[1]),
                zipSelected: false,
                patient_mobile_country_code: this.split_request_data[0].patient_mobile_country_code || this.planInfo.apf_patient_mobile_country_code || this.patientData.apf_patient_mobile_country_code,
              });
              if (this.split_request_data && (this.split_request_data[0].country_id == 7)) {
                this.australiaChange(this.split_request_data[0].patient_mobile_country_code);
              }
              if (!this.patient_address.controls['patient_mobile_country_code'].value) {
                if (this.mainService.country_data && this.mainService.country_data.length) {
                  // tslint:disable-next-line:no-string-literal
                  this.patient_address.patchValue({ patient_mobile_country_code: this.mainService.country_data[0]['mobile_code'] });
                  this.flag_code = (this.mainService.country_data[0]['country_code'] + '').toLocaleLowerCase();

                }
              } else {
                if (this.mainService.country_data && this.mainService.country_data.length) {
                  this.flag_code = this.mainService.findFlagCode(this.patient_address.value['patient_mobile_country_code']);
                }
                // const filter = this.mainService.country_data && this.mainService.country_data.filter(item => item.mobile_code == this.patient_address.value['patient_mobile_country_code']);
                // if (filter && filter.length) {
                //   this.flag_code = filter[0]['country_code'];
                // }
              }
              if (this.patientData['patient_email'] || this.split_request_data[0].patient_email || this.planInfo.apf_patient_email) {
                this.patient_address.controls.patient_email.disable();
                this.patient_address.updateValueAndValidity();
              }
              if (this.patientData['patient_ssn']) {
                this.patient_address.controls.patient_ssn.disable();
                this.patient_address.updateValueAndValidity();
              }
              let customerZip = {
                zip: '',
                city: '',
                city_id: '',
                state_name: '',
                state_code: ''
              };
              if (this.patientData['zip'] || this.planInfo['zip']) {
                customerZip = {
                  zip: this.planInfo['zip'] || this.patientData['zip'],
                  city: this.planInfo['city'] || this.patientData['city'],
                  city_id: this.planInfo['city_id'] || this.patientData['city_id'],
                  state_name: this.planInfo['state'] || this.patientData['state_name'],
                  state_code: this.planInfo['state_code'] || this.patientData['state_code'],
                };
              }
              this.selectZip(customerZip);
            }, 200);
          }
        }
        this.route.queryParams.subscribe((resp: any) => {
          if (resp.from_mobile && resp.from_mobile == '1') {
            this.from_mobile = true;
          }
          // console.log(resp);
          if (resp && resp.step) {
            this.mainService.current_step = 3;
            this.opened_step = 3;
            this.routeStep = true;
            // if (resp.redirect_url) {
            // }
            this.redirect_url = resp.redirect_url;
            this.panel = resp.redirect_url && resp.redirect_url.includes("business") ? "business" : "request";
          }
          if (resp && resp.scanner_continue) {
            this.scanner_continue = JSON.parse(resp.scanner_continue);
            // this.stepThree = JSON.parse(resp.step)
          }
          if (resp && resp.manual_continue) {
            this.manual_continue = JSON.parse(resp.manual_continue);
            console.log(resp);
            // this.stepThree = JSON.parse(resp.step)
          }
        });
        this.setData(data);
      }
    })

    // this.plaidService.plaid_success_subject.subscribe((data: any) => {
    //   if (data == 1) {
    //     this.new_bank_added = 1;
    //   }
    // });
    this.new_bank_added = 0;

    console.log(this.canvasDiv, 'native native');


    this.mainService.finance_error_from = 'Payment Link';
  }

  ngOnChanges() {
    console.log(this.canvasDiv.nativeElement, 'native native');
    
  }
 
  updateMasking(format: '') {
    format = format ? format : "";
    this.mask = format.replace(/#/g, '0');
    // this.mask = '0000-000-000';
  }
  showElementTrigger(event) {
    this.showElement = event;
    setTimeout(() => {
      this.openAddBankPopup(this.payment_source_type);
    }, 500);
  }

  // initSignPad() {
  //   setTimeout(() => {
  //     if (this.signaturePad && !this.signature) {
  //       this.signaturePad.set('canvasWidth', this.canvasDiv.nativeElement.offsetWidth);
  //       this.signaturePad.set('canvasHeight', this.canvasDiv.nativeElement.offsetHeight);
  //       this.signaturePad.clear();
  //     }
  //   }, 200);
  // }

  clearSign() {
    // this.signaturePad.clear();
    this.signaturePadComponent.clear();

    this.signature = '';
  }

  drawComplete(dataUrl: string) {
    if (!dataUrl) {
      this.signature = '';
      return;
    }

    // this.signatureUrl = this.signaturePad.toDataURL();
    const dataURI = dataUrl;
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: 'image/jpeg'
    });
    this.signature = blob;
  }

  checkNavigationData() {
    if (this.contractToken && localStorage.getItem('navigation_data')) {
      const data = JSON.parse(localStorage.getItem('navigation_data'));
      if (this.contractToken) {
        const navigation_data = data[this.contractToken];
        if (navigation_data) {
          if (navigation_data.payment_step) {
            this.payment_step = navigation_data.payment_step;
            this.mod_step = navigation_data.payment_step;
            if (this.payment_step == 4) {
              // this.initSignPad();
            }
          } else {
            this.payment_step = 0;
            this.mod_step = 1;
          }
          if (navigation_data.recurring_source_id) {
            this.recurring_source_id = navigation_data.recurring_source_id;
            const matched_source = this.patientData['payment_sources'].filter(source => source.source_id === this.recurring_source_id);
            if (matched_source && matched_source[0]) {
              this.selected_recurring_card = matched_source[0];
            } else {
              this.recurring_source_id = null;
              this.payment_step = 2;
              this.mod_step = 2;
            }
          } else {
            this.payment_step = 2;
            this.mod_step = 2;
          }
          if (navigation_data.dp_source_id) {
            this.dp_source_id = navigation_data.dp_source_id;
            const matched_source = this.patientData['payment_sources'].filter(source => source.source_id === this.dp_source_id);
            if (matched_source && matched_source[0]) {
              this.selected_dp_card = matched_source[0];
            } else {
              this.dp_source_id = null;
              this.payment_step = 1;
              this.mod_step = 1;
            }
          } else {
            this.payment_step = 1;
            this.mod_step = 1;
          }
          if (navigation_data.backup_source_id) {
            this.backup_source_id = navigation_data.backup_source_id;
            const matched_source = this.patientData['payment_sources'].filter(source => source.source_id === this.backup_source_id);
            if (matched_source && matched_source[0]) {
              this.selected_backup_card = matched_source[0];
            } else {
              this.backup_source_id = null;
            }
          }
        }
      }
    }
  }

  checkPaymentSources() {
    if (!this.patientData['payment_sources']) {
      this.patientData['payment_sources'] = [];
    }

    const data = JSON.parse(localStorage.getItem('navigation_data'));
    if (data && data[this.contractToken] && data[this.contractToken].opened_step) {
      this.mod_step = data[this.contractToken].opened_step || 1
    }

    if (this.patientData['payment_sources'].length > 0) {
      if (Number(this.new_bank_added) === 1) {
        const banks = this.patientData['payment_sources'].filter(source => Number(source.payment_source_type) === 1);
        if (banks && banks[0]) {
          if (Number(this.mod_step) === 1) {
            this.dp_source_id = banks[0].source_id;
            this.primaryCardChanged(banks[0].payment_source_type, banks[0].source_id);
          } else if (Number(this.mod_step) === 2) {
            this.recurring_source_id = banks[0].source_id;
          } else if (Number(this.mod_step) === 3) {
            this.backup_source_id = banks[0].source_id;
          }
          if (window.screen.width < 768) {
            if (Number(this.mod_step) === 1) {
              this.opened_step = 2;
              this.payment_step = 2;
            } else if (Number(this.mod_step) === 2) {
              this.opened_step = 3;
              this.payment_step = 3;
            } else if (Number(this.mod_step) === 3) {
            }
            this.setNavigationData();
          }
        }
        this.new_bank_added = 0;
      }
      if (Number(this.recurring_source_id) === -1) {
        this.planInfo.selected_payment_matrix.backup_type = 2;
      }
      if (this.selected_recurring_card && Number(this.selected_recurring_card.payment_source_type) === 1) {
        this.planInfo.selected_payment_matrix.backup_type = 2;
      }
      if (this.selected_recurring_card && Number(this.selected_recurring_card.payment_source_type) !== 1) {
        this.planInfo.selected_payment_matrix.backup_type = this.split_request_data[0].payment_matrix_array[0].backup_type
      }

      this.patientData['primary_sources'] = this.patientData['payment_sources'].filter(source => {
        return Number(this.planInfo.selected_payment_matrix.primary_type) === 3 || (Number(this.planInfo.selected_payment_matrix.primary_type) === 1 && Number(source.payment_source_type) === 1) || (Number(this.planInfo.selected_payment_matrix.primary_type) === 2 && Number(source.payment_source_type) !== 1);
      });
      // this.patientData['recurring_sources'] = this.patientData['payment_sources'].filter(source => {
      //   return Number(this.planInfo.selected_payment_matrix.recurring_type) === 3 || (Number(this.planInfo.selected_payment_matrix.recurring_type) === 1 && Number(source.payment_source_type) === 1) || (Number(this.planInfo.selected_payment_matrix.recurring_type) === 2 && Number(source.payment_source_type) !== 1);
      // });

      this.patientData['recurring_sources'] = this.patientData['payment_sources'].filter(source => {
        // tslint:disable-next-line:max-line-length
        return ((this.planInfo.selected_payment_matrix.recurring_type == 3) || (this.planInfo.selected_payment_matrix.recurring_type == 1 && source.payment_source_type == 1) || (this.planInfo.selected_payment_matrix.recurring_type == 2 && source.payment_source_type != 1));
      });

      // this.patientData['backup_sources'] = this.patientData['payment_sources'].filter(source => {
      //   return (Number(this.planInfo.selected_payment_matrix.backup_type) === 3 || (Number(this.planInfo.selected_payment_matrix.backup_type) === 1 && Number(source.payment_source_type) === 1) || (Number(this.planInfo.selected_payment_matrix.backup_type) === 2 && Number(source.payment_source_type) !== 1)) && (!this.recurring_source_id || this.recurring_source_id !== source.source_id);
      // });
      this.patientData['backup_sources'] = this.patientData['payment_sources'].filter(source => {
        // tslint:disable-next-line:max-line-length
        return (this.planInfo.selected_payment_matrix.backup_type == 3 || (this.planInfo.selected_payment_matrix.backup_type == 1 && source.payment_source_type == 1) || (this.planInfo.selected_payment_matrix.backup_type == 2 && source.payment_source_type != 1));
      });
    } else {
      this.patientData['primary_sources'] = [];
      this.patientData['recurring_sources'] = [];
      this.patientData['backup_sources'] = [];
    }
    const card_primary_sources = this.patientData['primary_sources'].filter(source => source.payment_source_type !== 1);
    const card_recurring_sources = this.patientData['recurring_sources'].filter(source => source.payment_source_type !== 1);
    const card_backup_sources = this.patientData['backup_sources'].filter(source => source.payment_source_type !== 1);
    this.primary_card_added = card_primary_sources && card_primary_sources.length > 0 ? 1 : 0;
    this.recurring_card_added = card_recurring_sources && card_recurring_sources.length > 0 ? 1 : 0;
    this.backup_card_added = card_backup_sources && card_backup_sources.length > 0 ? 1 : 0;
    if (this.recurring_source_id === -1) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    }
    if (this.selected_dp_card === undefined) {
      if (this.dp_source_id) {
        const matched_source = this.patientData['payment_sources'].filter(source => Number(source.source_id) === Number(this.dp_source_id));
        if (matched_source && matched_source[0]) {
          this.selected_dp_card = matched_source[0];
        }
      }
    }
    if (this.selected_recurring_card === undefined) {
      if (this.recurring_source_id) {
        const matched_source1 = this.patientData['payment_sources'].filter(source => Number(source.source_id) === Number(this.recurring_source_id));
        if (matched_source1 && matched_source1[0]) {
          this.selected_recurring_card = matched_source1[0];
        }
      }
    }
    if (this.planInfo.allow_one_card === 1) {
      if (this.dp_source_id === this.recurring_source_id) {
        this.planInfo.selected_payment_matrix.backup_required = 0;
      } else if (this.dp_source_id && this.recurring_source_id) {
        if (this.selected_dp_card && this.selected_dp_card.fingerprint && this.selected_recurring_card && this.selected_recurring_card.fingerprint && this.selected_dp_card.fingerprint === this.selected_recurring_card.fingerprint) {
          this.planInfo.selected_payment_matrix.backup_required = 0;
        }
      }
    } else if (this.selected_dp_card && this.selected_recurring_card && this.selected_dp_card.fingerprint === this.selected_recurring_card.fingerprint) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    }

    if (this.selected_dp_card && this.selected_recurring_card && this.selected_dp_card.fingerprint !== this.selected_recurring_card.fingerprint && this.planInfo.payment_matrix_array[0].backup_required) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    }
    else {
      this.planInfo.selected_payment_matrix.backup_required = 0;
    }

    if (data && data[this.contractToken] && data[this.contractToken].opened_step) {
      this.mod_step = data[this.contractToken].opened_step
    }


    let card_primary_sources_1 = []
    let card_recurring_sources_1 = []
    let card_backup_sources_1 = []

    if (this.contractToken && data && data[this.contractToken]) {

      card_primary_sources_1 = this.patientData['primary_sources'].filter(item => { return item.source_id == (this.dp_source_id || data[this.contractToken] && data[this.contractToken].dp_source_id) });
      card_recurring_sources_1 = this.patientData['recurring_sources'].filter(item => { return item.source_id == (this.recurring_source_id || data[this.contractToken] && data[this.contractToken].recurring_source_id) });
      card_backup_sources_1 = this.patientData['backup_sources'].filter(item => { return item.source_id == (this.backup_source_id || data[this.contractToken] && data[this.contractToken].backup_source_id) });

    }

    if (card_primary_sources_1.length == 0) {
      this.dp_source_id = 0;
    }
    if (card_recurring_sources_1.length == 0) {
      this.recurring_source_id = 0;
    }
    if (card_backup_sources_1.length == 0) {
      this.backup_source_id = 0;
    }
  }

  setData(data: any) {
    this.plans = data;
    this.planInfo = data.split_request_data[0];
    if (this.planInfo.doctor_id && this.routeStep) {
      if (this.mainService.socket && !this.mainService.socket.connected) {
        this.mainService.socket.connect();
      }
      // this._socket.emit(this.mainService.socketIDS.START_LOADING, {doctor_id: this.planInfo.doctor_id});
      this.mainService.socket.emit(this.mainService.socketIDS.START_LOADING, {doctor_id: this.planInfo.doctor_id});
    }
    this.enrollment_fee = this.planInfo.plans_array ? this.planInfo.plans_array[0].enrollment_fee : 30;
    this.contract_service_record = this.planInfo && this.planInfo.contract_service_record;
    console.log(this.planInfo);
    
    if (this.planInfo.selected_payment_matrix == undefined) {
      this.planInfo.selected_payment_matrix = {
        backup_required: 0,
        backup_type: 2,
        primary_type: 2,
        recurring_type: 2
      }
    }
    this.planInfo.credit_report_status = Number((this.planInfo.hasOwnProperty('credit_report_status') ? this.planInfo.credit_report_status : 0));
    this.planInfo.credit_report_amount = Number((this.planInfo.hasOwnProperty('credit_report_amount') ? this.planInfo.credit_report_amount : 0));
    if(this.planInfo.credit_report_amount && this.planInfo.credit_report_status){
      this.creditReportOption = true;
      this.customerSelection = true;

    } else{
      this.creditReportOption = false;
    }
    this.planInfo.patient_address = this.planInfo.patient_address && this.planInfo.patient_address !== null ? this.planInfo.patient_address : this.patientData['patient_address'];
    this.planInfo.zip = this.planInfo.zip && this.planInfo.zip !== null ? this.planInfo.zip : this.patientData['zip'];
    this.planInfo.state = this.planInfo.state && this.planInfo.state !== null ? this.planInfo.state : this.patientData['state_name'];
    this.planInfo.city = this.planInfo.city && this.planInfo.city !== null ? this.planInfo.city : this.patientData['city'];

    if (this.actual_matrix === undefined && Number(this.new_bank_added) !== 1) {
      this.actual_matrix = JSON.parse(JSON.stringify(this.planInfo.selected_payment_matrix));
    }
    if (this.dp_source_id && this.recurring_source_id && Number(this.dp_source_id) == Number(this.recurring_source_id) && this.planInfo.selected_payment_matrix) {
      this.planInfo.selected_payment_matrix.backup_required = 1;
    }
    this.checkPaymentSources();

    if (this.planInfo.start_date && this.planInfo.end_date) {

      let today = new Date();
      let start_date = new Date(this.planInfo.start_date);

      if (today > start_date) {
        start_date = new Date(new Date().setDate(new Date().getDate() + 1));
      }
      let first_recurring_days = data.split_request_data[0].first_recurring_days ? data.split_request_data[0].first_recurring_days : 0;
      this.planInfo.min_date = new Date(parseInt(this.datePipe.transform(start_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(start_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(start_date, 'dd', this.timezone)) + (this.planInfo.recurring_days - 1))
      const rec_days = this.planInfo && this.planInfo.contract_type == 6 ? this.planInfo.first_recurring_days_deferred : this.planInfo.split_plan_gap_days;
      this.planInfo.max_date = new Date(parseInt(this.datePipe.transform(this.planInfo.end_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(this.planInfo.end_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(this.planInfo.end_date, 'dd', this.timezone)) + (rec_days || 30));
      if (this.planInfo.is_ar_contract == 1) {
        let add_1_month = new Date(parseInt(this.datePipe.transform(start_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(start_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(start_date, 'dd', this.timezone)) + ((this.planInfo.split_plan_gap_days || 30) - 1));
        this.planInfo.max_date = add_1_month;
        let end_date = new Date(parseInt(this.datePipe.transform(this.planInfo.start_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(this.planInfo.start_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(this.planInfo.start_date, 'dd', this.timezone)) + (this.planInfo.ar_split_plan_gap_days || 60));
        if (add_1_month > end_date) {
          this.paymentDetails.recurringDate = this.planInfo.max_date;
        } else {
          this.planInfo.max_date = end_date;
          this.paymentDetails.recurringDate = add_1_month;
        }
      }
      else {
        const rec_days = this.planInfo && this.planInfo.contract_type == 6 ? this.planInfo.first_recurring_days_deferred : first_recurring_days;
        let add_1_month = new Date(parseInt(this.datePipe.transform(start_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(start_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(start_date, 'dd', this.timezone)) + ((rec_days) - 1));
        let end_date = new Date(parseInt(this.datePipe.transform(this.planInfo.end_date, 'yyyy', this.timezone)), parseInt(this.datePipe.transform(this.planInfo.end_date, 'MM', this.timezone)) - 1, parseInt(this.datePipe.transform(this.planInfo.end_date, 'dd', this.timezone)) + (rec_days));
        if (add_1_month > end_date) {
          this.planInfo.max_date = end_date;
          this.paymentDetails.recurringDate = this.planInfo.max_date;
        } else {
          this.paymentDetails.recurringDate = add_1_month;
        }
      }
      this.planInfo.max_date = this.paymentDetails.recurringDate;
      this.planInfo.selected_plan = this.planInfo.plans_array[0];
      // console.log('this.planInfo.selected_plan', typeof this.planInfo.selected_plan.recurring_amount);
    }
    if (this.planInfo.request_from == 1) {
      if (this.planInfo.next_payment_start_date && this.planInfo.next_payment_end_date) {
        if (this.planInfo.next_payment_end_date && this.mainService.getExactDate(new Date(this.planInfo.next_payment_end_date)) > this.mainService.getExactDate(new Date())) {
          this.paymentDetails.recurringDate = this.mainService.getExactDate(new Date(this.planInfo.next_payment_start_date)) > this.mainService.getExactDate(new Date()) ? this.mainService.getExactDate(new Date(this.planInfo.next_payment_start_date)) : new Date(new Date().setDate(new Date().getDate() + 1));
          // this.planInfo.min_date = this.paymentDetails.recurringDate;
          this.planInfo.max_date = this.mainService.getExactDate(new Date(this.planInfo.next_payment_end_date));
          this.planInfo.disable_recurring = 1;
        } else {
          this.planInfo.disable_recurring = 0;
        }
      } else {
        this.planInfo.disable_recurring = 0;
      }
    } else {
      this.planInfo.disable_recurring = 0;
    }
    this.calculateTotalPayable();

    if (this.planInfo && this.planInfo.show_closure_form) {
      this.show_closure_form = 1;
    }

    if (this.planInfo && this.planInfo.contract_service_record && typeof this.planInfo.contract_service_record === 'string') {
      this.planInfo.contract_service_record = JSON.parse(this.planInfo.contract_service_record);
    }

    let tilaData;
    tilaData = {};

    tilaData['current_plan'] = JSON.stringify(data['split_request_data'][0].plans_array[0]);
    tilaData['contract_patient_token'] = data['split_request_data'][0].contract_patient_token;
    tilaData['contract_type'] = data['split_request_data'][0].contract_type;
    tilaData['start_date'] = this.datePipe.transform(this.paymentDetails.recurringDate || data['split_request_data'][0].start_date, 'yyyy-MM-dd');

    localStorage.setItem('iframe_tila_data', JSON.stringify(tilaData));

  };

  dateChanged(date?) {
    let tilaData;
    tilaData = JSON.parse(localStorage.getItem('iframe_tila_data'));
    // console.log('values changed')
    tilaData = { ...tilaData, start_date: this.datePipe.transform(date, 'yyyy-MM-dd') };
    localStorage.setItem('iframe_tila_data', JSON.stringify(tilaData));
  }


  calculateTotalPayable() {
    try {
      let fixed_flat_fee = this.planInfo && this.planInfo.enrollment_enabled ? 0 : this.enrollment_fee;
      fixed_flat_fee = this.is_waived ? 0 : fixed_flat_fee;
      if (this.planInfo && this.planInfo.plans_array && this.planInfo.plans_array.length > 0) {
        this.planInfo.plans_array.forEach((item: any) => {
          if (this.planInfo.contract_type === 1) {
            if (this.planInfo.payment_reserve_on_pay) {
              item.advance_interest_amount = item.recurring_amount;
            } else {
              item.advance_interest_amount = 0;
            }
          } else if (this.planInfo.contract_type === 3) {
            if (this.planInfo.payment_reserve_on_pay_new_ten) {
              item.advance_interest_amount = item.recurring_amount;
            } else {
              item.advance_interest_amount = 0;
            }
          } else {
            item.advance_interest_amount = item.advance_interest_amount ? parseFloat(parseFloat(
              item.advance_interest_amount
            ).toFixed(2)) : 0;
          }
          // tslint:disable-next-line:max-line-length
          item.total_payable_amount = parseFloat(this.planInfo.downpayment_amount) + parseFloat(fixed_flat_fee.toString()) + this.mainService.getCalculatedTransactionFee(this.planInfo, this.planInfo.downpayment_amount) + parseFloat(item.advance_interest_amount) + this.mainService.getCalculatedTransactionFee(this.planInfo, item.advance_interest_amount);
          if (this.planInfo.credit_report_status && this.planInfo.credit_report_amount) {
            item['recurring_amount_with_credit_fee']   = item.recurring_amount + this.planInfo.credit_report_amount;
            item['advance_interest_amount_with_credit_fee']   = item.advance_interest_amount + this.planInfo.credit_report_amount;
            item['creditReportOption'] = true;
          }
        });
      }
    } catch (error) {
      // console.log(error);
    }
  }

  ShowStripeElement() {
    this.mainService.stripe_element.update({
      hidePostalCode: false
    });
    this.mainService.stripe_element.addEventListener('change', ({ data, error }) => {
      if (error) {
        this.cardError = error.message;
      } else {
        this.cardError = '';
      }
    });
  }

  changeCard() {
    this.payment_step = 1;
    this.mod_step = 1;
    // this.paymentDetails.cardName = '';
    this.mainService.stripe_element.clear();
    this.modalRef.hide();
  }

  AddStripeElement(element_id) {
    this.selected_card = '';
    return;
    if (element_id == 'card-element' || element_id == 'add_new_card' || element_id == 'add_new_card1') {
      this.mainService.stripe_element.update({
        hidePostalCode: false
      });
    } else {
      this.mainService.stripe_element.update({
        hidePostalCode: true
      });
    }
    setTimeout(() => {
      this.mainService.stripe_element.mount('#' + element_id);
    }, 1000);
  }

  RemoveStripeElement(element_id) {
    this.mainService.stripe_element.unmount('#' + element_id);
  }

  GetStripeToken(button_action) {
    this.buttonClickedSubject.next(button_action);
  }

  selectZip(zipObj: any) {
    // console.log(zipObj, "zipObj");

    try {
      if (zipObj !== '') {
        this.zipPostalCode = zipObj.zip;
        this.zipCode = zipObj;
        this.patient_address.controls.city_id.setValue(zipObj.city_id);
        this.patient_address.controls.city.setValue(zipObj.city);
        this.patient_address.controls.state_name.setValue(zipObj.state_name);
        this.patient_address.controls.state_code.setValue(zipObj.state_code);
        this.patient_address.controls.zip.setValue(zipObj.zip);
        this.patient_address.controls.address.setValue(zipObj.formatted_address || zipObj.item.formatted_address);
        this.patient_address.controls.zipSelected.setValue(true);
        this.patient_address.updateValueAndValidity();
      } else {
        this.zipPostalCode = '';
        this.zipCode = {
          zip: '',
          state: '',
          city: '',
          city_id: '',
          formatted_address: '',
        };
        this.patient_address.controls.city_id.setValue('');
        this.patient_address.controls.city.setValue('');
        this.patient_address.controls.state_name.setValue('');
        this.patient_address.controls.zip.setValue('');
        this.patient_address.controls.address.setValue('');
        this.patient_address.controls.zipSelected.setValue(true);
        this.patient_address.updateValueAndValidity();
      }
    } catch (err) {
      // console.log(err);
    }

  }

  addAddressFn(from) {
    if (!from) {
      from.markAsTouched()
    }
    if (this.patient_address && !this.patient_address.value.patient_first_name || this.patient_address.value.patient_first_name.trim().length == 0) {
      // this.toaster.message('warning', 'Please enter First Name', '');
      this.showError =  true;
      if (this.el.nativeElement.querySelector('[name="patient_first_name"]')) {
        this.el.nativeElement.querySelector('[name="patient_first_name"]').focus();
      }
      return;
    }
    if (this.patient_address && !this.patient_address.value.patient_last_name || this.patient_address.value.patient_last_name.trim().length == 0) {
      // this.toaster.message('warning', 'Please enter Last Name', '');
      if (this.el.nativeElement.querySelector('[name="patient_last_name"]')) {
        this.el.nativeElement.querySelector('[name="patient_last_name"]').focus();
      }
      this.showError =  true;
      return;
    }
    if (this.patient_address && !this.patient_address.value.language_preffered || this.patient_address.value.language_preffered.trim().length == 0) {
      this.toaster.message('Please Select Preferred Language', 3)
      return
    }
    if (!new RegExp(this.mobile_pattern).test(this.patient_address.controls.patient_mobile_country_code.value + this.patient_address.controls.patient_mobile.value)) {
      // this.toaster.message('warning', 'Please enter a valid phone number', '');
      if (this.el.nativeElement.querySelector('[name="patient_mobile"]')) {
        this.el.nativeElement.querySelector('[name="patient_mobile"]').focus();
      }
      this.showMobError = true
      this.showError =  true;
      return;
    } else{
      this.showMobError = false;
    }
    if (this.patient_address && !this.patient_address.value.address || this.patient_address.value.address.trim().length == 0) {
      // this.toaster.message('warning', 'Please enter Address', '');
      if (this.el.nativeElement.querySelector('[name="address"]')) {
        this.el.nativeElement.querySelector('[name="address"]').focus();
        this.showError =  true;
      }
      return;
    }
    if (this.patient_address && !this.patient_address.controls.zip.value || this.patient_address.controls.zip.value.trim().length == 0) {
      // this.toaster.message('warning', 'Please enter Zip/Postal code', '');
      if (this.el.nativeElement.querySelector('[name="zip"]')) {
        this.el.nativeElement.querySelector('[name="zip"]').focus();
        this.showError =  true;
      }
      return;
    }
    // tslint:disable-next-line:max-line-length
    if (!this.patient_address.controls.patient_email.disabled && this.patient_address && !this.patient_address.value.patient_email || (this.patient_address.value.patient_email && this.patient_address.value.patient_email.trim().length == 0)) {
      this.toaster.message('Please enter Email', 3);
      return;
    }
    const invalid_ssn = ['002281852', '042103580', '062360749', '078051120', '095073645', '128036045', '135016629', '141186941', '165167999', '165187999', '165207999', '212099999', '165227999', '306302348', '165247999', '189092294', '308125070', '212097694', '549241889', '468288779'];
    if (this.mainService.currency_data.country_code == 'US') {
      if (!this.mainService.validateSSN(this.patient_address && this.patient_address.value && this.patient_address.value.patient_ssn ? this.patient_address.value.patient_ssn : this.patientData['patient_ssn'])) {
        this.el.nativeElement.querySelector('[name="patient_ssn"]').focus();
        this.errorMsg = 'Please enter a valid ' + this.mainService.document_label;
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter valid SSN', '');
        return;
      }
    } else {
      if (this.showSSNfields && this.patient_address && !this.patient_address.controls.patient_ssn.disabled && (!this.patient_address.value.patient_ssn || Number(String(this.patient_address.value.patient_ssn).trim().length) === 0 || Number(String(this.patient_address.value.patient_ssn).trim().length) < this.mainService.minDocumentIdLength || Number(String(this.patient_address.value.patient_ssn).trim().length) > this.mainService.maxDocumentIdLength || invalid_ssn.includes(String(this.patient_address.value.patient_ssn).trim()))) {
        // this.toaster.message('warning', 'Please enter a valid ' + this.mainService.document_label, '');
        this.el.nativeElement.querySelector('[name="patient_ssn"]').focus();
        this.errorMsg = 'Please enter a valid ' + this.mainService.document_label;
        this.showvalidation = true;
        return;
      }
    }
    this.errorMsg = '';
    this.showvalidation = false;
    // const ssnPattern = new RegExp(/^[a-zA-Z0-9_]*$/);

    // const invalid_ssn = ['002281852', '042103580', '062360749', '078051120', '095073645', '128036045', '135016629', '141186941', '165167999', '165187999', '165207999', '212099999', '165227999', '306302348', '165247999', '189092294', '308125070', '212097694', '549241889', '468288779'];
    // if (this.mainService.document_label == 'SSN/EIN') {
    //   if (this.showSSNfields && this.patient_address && !this.patient_address.controls.patient_ssn.disabled && (!this.patient_address.value.patient_ssn || Number(String(this.patient_address.value.patient_ssn).trim().length) === 0 || Number(String(this.patient_address.value.patient_ssn).trim().length) < 9 || Number(String(this.patient_address.value.patient_ssn).trim().length) > 9 || invalid_ssn.includes(String(this.patient_address.value.patient_ssn).trim()))) {
    //     this.toaster.message('warning', 'Please enter a valid ' + this.mainService.document_label, '');
    //     return;
    //   }
    // } else {
    //   if (this.showSSNfields && this.patient_address && !this.patient_address.controls.patient_ssn.disabled && (!this.patient_address.value.patient_ssn || Number(String(this.patient_address.value.patient_ssn).trim().length) === 0 || Number(String(this.patient_address.value.patient_ssn).trim().length) < this.mainService.minDocumentIdLength || Number(String(this.patient_address.value.patient_ssn).trim().length) > this.mainService.maxDocumentIdLength || invalid_ssn.includes(String(this.patient_address.value.patient_ssn).trim()))) {
    //     this.toaster.message('warning', 'Please enter a valid ' + this.mainService.document_label, '');
    //     return;
    //   }
    // }

    // if (!new RegExp(this.mobile_pattern).test(this.patient_address.value.patient_mobile_country_code + this.patient_address.value.patient_mobile)) {
    //   this.toaster.message('warning', 'Please enter a valid phone number', '');
    //   return;
    // }

    let params = {
      contract_patient_token: this.contractToken,
      address: this.patient_address.value.address_2 ? this.patient_address.value.address + " || " + this.patient_address.value.address_2 : this.patient_address.value.address,
      city_id: this.patient_address.value.city_id,
      patient_first_name: this.patient_address.value.patient_first_name,
      patient_last_name: this.patient_address.value.patient_last_name,
      patient_email: this.split_request_data[0].patient_email || this.patient_address.value.patient_email || this.patientData['patient_email'],
      patient_mobile: this.patient_address.value.patient_mobile.replace(/[^0-9]/g, ''),
      patient_mobile_country_code: this.patient_address.controls.patient_mobile_country_code.value,
      language_preffered: this.patient_address.value.language_preffered
    }

    if (this.showSSNfields) {
      params['patient_ssn'] = this.patient_address.value.patient_ssn || this.patientData['patient_ssn'];
    }

    let form = new FormData();
    for (var key in params) {
      form.append(key, String(params[key]));
    }
    if (this.signature) {
      form.append('patient_signature', this.signature);
    }
    this.mainService.setLoader(true);
    if (this.paymentLoader) {
      return false;
    } else {
      this.paymentLoader = true;
      this.proposal.formApi('post', 'add_patient_address', form)
        .subscribe((data: any) => {
          this.paymentLoader = false;
          this.mainService.setLoader(false);
          if (data && typeof data == 'string') data = JSON.parse(data);
          if (data.is_error == 1) {
            if (data.override_text || data.err) {
              this.toaster.message(data.override_text || data.err, 3);
              return false;
            }
          }
          if (data.is_error === 0) {
            this.opened_step = 3;
            this.mainService.current_step = 3;
            const zip = data.addressInfo;
            let address1 = zip.patient_address && zip.patient_address.includes("||") ? zip.patient_address.split("||")[0].trim() : zip.patient_address
            this.patient_address.controls.address.setValue(address1);
            this.patient_address.controls.city.setValue(zip.city);
            this.patient_address.controls.state_name.setValue(zip.state);
            this.patient_address.controls.zip.setValue(zip.zip);
            this.patient_address.controls.city_id.setValue(zip.city_id);
            this.patient_address.controls.patient_first_name.setValue(zip.patient_first_name);
            this.patient_address.controls.patient_last_name.setValue(zip.patient_last_name);
            this.patient_address.controls.patient_email.setValue(zip.patient_email);
            if (this.patient_address.value.zip) {
              this.zips = [{ zip: this.patient_address.value.zip, state_name: this.patient_address.value.state_name, city: this.patient_address.value.city, city_id: this.patient_address.value.city_id }];
            }
            if (zip && zip.patient_mobile && zip.patient_mobile.split('-').length > 1) {
              this.patient_address.value.patient_mobile = zip.patient_mobile.split('-')[1];
            }
          }
        }, (error: any) => {
          // console.log(error);
          this.paymentLoader = false;
          this.mainService.setLoader(false);
        });
    }
  }

  acceptClosure(modal?) {
    this.closure_terms = true;
    this.createContract();
  }

  detectChange() {
    this.cd.detectChanges();
  }

  back() {
    this.payment_step--;
    this.mod_step--;
    this.setNavigationData();
  }
  smallSizeBack() {
    if (this.mod_step != 4 && this.mod_step != 0) {
      this.payment_step = 0;
      this.mod_step = 0;
    } else if (this.payment_step == 4) {
      this.payment_step = 1;
      this.mod_step = 1;
    } else {
      if (this.payment_step == 4) {
        this.payment_step = 0;
        this.mod_step = 0;
      }
    }
    this.setNavigationData();
  }

  nextStep(modal?) {
    this.selected_backup_card = undefined;

    if (this.payment_step == 0) {
      this.payment_step = 1;
      this.mod_step = 1;
    } else if (this.payment_step == 1) {
      if (!this.dp_source_id) {
        this.toaster.message('Please add/select a payment method for the payment', 3);
        this.mod_step = 1;
        return false;
      }
      let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.dp_source_id)
      if (matched_source && matched_source[0]) {
        this.selected_dp_card = matched_source[0];
      }
      if (this.actual_matrix) {
        this.planInfo.selected_payment_matrix = JSON.parse(JSON.stringify(this.actual_matrix));
      }
      this.checkPaymentSources();
      this.payment_step = 2;
      this.mod_step = 2;
    } else if (this.payment_step == 2) {
      if (!this.dp_source_id) {
        this.toaster.message('Please add/select a payment method for the payment', 3);
        this.mod_step = 1;
        return false;
      }
      if (!this.recurring_source_id) {
        this.toaster.message('Please add/select a payment method for the recurring payment', 3);
        this.mod_step = 2;
        return false;
      }
      let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.recurring_source_id)
      if (matched_source && matched_source[0]) {
        this.selected_recurring_card = matched_source[0];
      }
      if (this.actual_matrix) {
        this.planInfo.selected_payment_matrix = JSON.parse(JSON.stringify(this.actual_matrix));
      }
      if (this.selected_dp_card && this.selected_recurring_card && this.selected_dp_card.payment_source_type == 1 && this.selected_recurring_card.payment_source_type == 1) {
        this.planInfo.selected_payment_matrix.backup_required = 1;
      }
      if (this.selected_recurring_card && this.selected_recurring_card.payment_source_type == 1) {
        this.planInfo.selected_payment_matrix.backup_type = 2;
      }
      if (this.dp_source_id == this.recurring_source_id) {
        this.planInfo.selected_payment_matrix.backup_required = 1;
      } else if (this.selected_dp_card && this.selected_recurring_card && this.selected_dp_card.fingerprint == this.selected_recurring_card.fingerprint) {
        this.planInfo.selected_payment_matrix.backup_required = 1;
      }
      if (this.recurring_source_id == -1) {
        this.planInfo.selected_payment_matrix.backup_required = 1;
      }
      this.backup_source_id = null;
      this.checkPaymentSources();
      this.payment_step = 3;
      this.mod_step = 3;
    } else if (this.payment_step == 3) {
      if (this.planInfo.selected_payment_matrix.backup_required == 1 && !this.backup_source_id) {
        this.toaster.message('Please add/select a payment method for the backup payment',3 );
        this.mod_step = 3;
        return false;
      }
      if (this.backup_source_id) {
        if (this.backup_source_id == this.recurring_source_id) {
          this.toaster.message('Recurring payment method and backup payment method cannot be same',3 );
          return false;
        }
        let matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.backup_source_id)
        if (matched_source && matched_source[0]) {
          this.selected_backup_card = matched_source[0];
        }
      }
      if (this.selected_backup_card && this.selected_backup_card.fingerprint && this.selected_recurring_card && this.selected_recurring_card.fingerprint && this.selected_backup_card.fingerprint == this.selected_recurring_card.fingerprint) {
        this.toaster.message('Recurring payment method and backup payment method cannot be same',3 );
        return false;
      }
      if (modal) {
        modal.hide();
      }
      this.payment_step = 4;
      this.mod_step = 4;
      // this.initSignPad();
    } else {
      if (!this.signature) {
        this.toaster.message('Signature not registered',3 );
        return false;
      }

      if (this.split_request_data[0].buss_terms_link && this.split_request_data[0].show_buss_terms && !this.check_business_terms) {
        this.toaster.message('Please accept Business terms & conditions', 3);
        return false;
      }

      if (!this.terms) {
        this.toaster.message('Please accept terms & conditions', 3);
        return false;
      }

      this.fullyCheckTheContract();
    }
    this.mainService.scrollToTop();
    this.setNavigationData();
  }

  setNavigationData() {
    let obj = {};
    obj[this.contractToken] = {
      payment_step: this.payment_step,
      opened_step: this.mod_step || 1,
      dp_source_id: this.dp_source_id,
      recurring_source_id: this.recurring_source_id,
      backup_source_id: this.backup_source_id
    }
    localStorage.setItem('navigation_data', JSON.stringify(obj));
  }

  primaryCardChanged(payment_source_type, source_id) {
    if (source_id !== -1 && Number(payment_source_type) == 1 && Number(this.planInfo.enrollment_waiver) == 1 && Number(this.planInfo.selected_payment_matrix.primary_type) == 3 && this.planInfo.enrollment_enabled == 0) {
      this.is_waived = 1;
    } else {
      this.is_waived = 0;
    }
    this.calculateTotalPayable();
  }

  fullyCheckTheContract() {
    if (!this.dp_source_id) {
      this.toaster.message("Please choose payment method for today's payment.", 3);
      this.payment_step = 1;
      this.mod_step = 1;
      this.setNavigationData();
      return false;
    }
    if (!this.recurring_source_id) {
      this.toaster.message("Please choose payment method for recurring payment.", 3);
      this.payment_step = 2;
      this.mod_step = 2;
      this.setNavigationData();
      return false;
    }
    if (this.show_closure_form) {
      if (this.patient_address.value && this.patient_address.value.patient_first_name && this.patient_address.value.patient_last_name && this.patient_address.value.address && this.patient_address.value.zip && this.patient_address.value.zip != '' && this.patient_address.value.zip != null) {
      } else if (this.planInfo && this.planInfo.apf_patient_last_name && this.planInfo.apf_patient_email) {
        this.patient_address.value.patient_first_name = this.planInfo.apf_patient_first_name;
        this.patient_address.value.patient_last_name = this.planInfo.apf_patient_last_name;
        this.patient_address.value.patient_email = this.planInfo.apf_patient_email;
        if (this.planInfo.apf_patient_mobile && this.planInfo.apf_patient_mobile.split('-').length > 1) {
          this.patient_address.value.patient_mobile = this.planInfo.apf_patient_mobile.split('-')[1];
        }
        if (this.planInfo && this.planInfo.patient_address && this.planInfo.zip && this.planInfo.zip != '' && this.planInfo.zip != null) {
          this.patient_address.value.address = this.planInfo.patient_address;
          this.patient_address.value.city = this.planInfo.city;
          this.patient_address.value.state_name = this.planInfo.state;
          this.patient_address.value.zip = this.planInfo.zip;
          this.patient_address.value.city_id = this.planInfo.city_id;

          if (this.patient_address.value.zip) {
            this.zips = [{ zip: this.patient_address.value.zip, state_name: this.patient_address.value.state_name, city: this.patient_address.value.city, city_id: this.patient_address.value.city_id }];
          }
        }
      }
    } else {
      this.createContract();
    }
  }

  CatchStripeTokenForNewCard(token_data, modal) {
    if (token_data.token && token_data.token.card && token_data.token.card.funding) {
      if (this.mainService.featureList && this.mainService.featureList.length) {
        const featureFilter = this.mainService.featureList.find(item => item.feature_enum === 'PAYMENTMETHOD');
        const getFeature = featureFilter ? JSON.parse(JSON.stringify(featureFilter)) : {};
        if (getFeature && getFeature.payment_method) {
          getFeature.payment_method = JSON.parse(getFeature.payment_method);
          // tslint:disable-next-line:max-line-length
          if (!getFeature.payment_method.includes((token_data.token.card.funding + '').toLocaleUpperCase())) {
            this.mainService.setLoader(false);
            this.toaster.message(`Payment type ${token_data.token.card.funding} is not supported as per your business plan`, 3);
            return false;
          }
        } else {
          this.mainService.setLoader(false);
          this.toaster.message(`Payment type is not supported as per your business plan.`, 3);
          return false;
        }
      }
    }
    if (token_data.token && token_data.token.card && token_data.token.card.brand) {
      const str = token_data.token.card.brand;
      const str2 = str.charAt(0).toUpperCase() + str.slice(1);
      token_data.token.card.brand = str2;
    }
    this.recurring_last4 = token_data.token.card.last4;
    this.recurring_token = token_data.token.id;
    let params = {
      contract_patient_token: this.contractToken,
      stripe_token: null,
      setup_id: token_data.token.id,
      payment_source_type: 3,
      contract_id: this.planInfo.contract_id
    }

    if (token_data.token && token_data.token.extra_data && token_data.token.extra_data.paymentIntentId) {
      params['payment_intent_id'] = token_data.token.extra_data.paymentIntentId      
    } 
    
    if (token_data.token && token_data.token.extra_data && token_data.token.extra_data.cardType) {
      params['card_type'] = token_data.token.extra_data.cardType      
    } 

    this.mainService.setLoader(true);
    if (this.paymentLoader) {
      return false;
    } else {
      this.paymentLoader = true;
      this.proposal.api('post', 'add_payment_source', this.mainService.urlParams(params))
        .subscribe((data: any) => {
          try {

            if (data && typeof data == 'string') data = JSON.parse(data);
            this.paymentLoader = false;
            this.mainService.setLoader(false);
            if (data.is_error == 0) {
              this.backUpCard = false;
              this.addNewPaymentMethodModal.hide();

              if (!this.patientData['payment_sources']) {
                this.patientData['payment_sources'] = [];
              }
              this.patientData['payment_sources'] = [...[{ source_id: data.source_id, brand: token_data.token.card.brand, last4: token_data.token.card.last4, fingerprint: data.fingerprint, card_type: data.card_type }], ...this.patientData['payment_sources']]
              this.checkPaymentSources();
              this.selected_card = data;
              this.saveCard();

              if (this.mod_step == 1) {
                this.dp_source_id = data.source_id;
                this.primaryCardChanged(2, this.dp_source_id);
                if (this.actual_matrix) {
                  this.planInfo.selected_payment_matrix = JSON.parse(JSON.stringify(this.actual_matrix));
                }
              } else if (this.mod_step == 2) {
                this.recurring_source_id = data.source_id;
                if (!this.dp_source_id && data.payment_source_type != 1) {
                  this.dp_source_id = JSON.parse(JSON.stringify(data.source_id));
                }
              } else if (this.mod_step == 3) {
                this.backup_source_id = data.source_id;
              }
              // if (window.screen.width < 768) {
              //   if (this.payment_step == 1) {
              //     this.mod_step = 2;
              //     this.payment_step = 2;
              //   } else if (this.payment_step == 2) {
              //     this.mod_step = 3;
              //     this.payment_step = 3;
              //   }
              // }
              this.showElement  = false;
              this.closeBank();
              this.setNavigationData();

            }
            if (data.is_error == 1) {
              this.showElement = false;
              this.callIntentApi();
              if (data.override_text || data.err) {
                this.toaster.message(data.override_text || data.err, 3);
              }
              this.addBankModal.hide();
              this.openModal_1(this.opened_step, this.addNewPaymentMethodModal);
            }

          } catch (error) {
            // console.log(error);

          }

        }, (error: any) => {
          // console.log(error);
          this.paymentLoader = false;
          this.mainService.setLoader(false);
        });
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-md modal-445 modal-dialog-centered', ignoreBackdropClick: true, keyboard: false });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.modalRef.hide();
      }
    });
  }

  uploadBusinessSignature() {
    if (this.patientData && this.patientData.total_automation_business && this.patientData.total_automation_business.length <= 0) {
      if (!this.signature) {
        this.mainService.customPopups("Please add Signature", 1);
        return;
      }

      const formData = new FormData();
      formData.append('patient_signature', this.signature);

      this.paymentLoader = true;
      this.mainService.setLoader(true);
      this.proposal.formApi('post', 'upload_signature', formData).subscribe((data) => {
        this.paymentLoader = false;
        this.mainService.setLoader(false);
        if (data.is_error == 0) {
          this.createContract(data.patient_signature)
        } else {
          this.mainService.customPopups(data.err, 1);
        }
      });
    } else {
      this.createContract(null)
    }
  }


  createContract(signature = null) {

    if (this.planInfo.selected_payment_matrix.backup_required && !this.backup_source_id) {
      this.mainService.customPopups('Please add a Backup Payment Method.', 1)
      return
    }

    if (!this.paymentDetails.recurringDate) {
      this.toaster.message('Please choose a valid recurring payment source.', 3);
      return;
    }

    if (this.planInfo.selected_payment_matrix.backup_required && !this.backup_source_id) {
      this.toaster.message('Please add Backup Payment Method.', 3);
      return false;
    }

    let contract_metadata = {
      allowed: {
        primary: this.actual_matrix.primary_type,
        recurring: this.actual_matrix.recurring_type,
        backup: this.actual_matrix.backup_type,
      },
      selected: {
        primary: this.selected_dp_card ? this.selected_dp_card.payment_source_type == 1 ? 1 : 2 : 0,
        recurring: this.selected_recurring_card ? this.selected_recurring_card.payment_source_type == 1 ? 1 : 2 : 0,
        backup: this.selected_backup_card ? this.selected_backup_card.payment_source_type == 1 ? 1 : 2 : 0.
      },
      last4: {
        primary: this.selected_dp_card && this.selected_dp_card.last4 ? this.selected_dp_card.last4 : '',
        recurring: this.selected_recurring_card && this.selected_recurring_card.last4 ? this.selected_recurring_card.last4 : '',
        backup: this.selected_backup_card && this.selected_backup_card.last4 ? this.selected_backup_card.last4 : ''
      },
      source_id: {
        primary: this.selected_dp_card && this.selected_dp_card.source_id ? this.selected_dp_card.source_id : 0,
        recurring: this.selected_recurring_card && this.selected_recurring_card.source_id ? this.selected_recurring_card.source_id : 0,
        backup: this.selected_backup_card && this.selected_backup_card.source_id ? this.selected_backup_card.source_id : 0
      },
      created_from: 1
    }

    let body = {
      contract_patient_token: this.contractToken,
      patient_signature: signature,
      contract_type: this.planInfo.contract_type,
      start_date: this.datePipe.transform(this.paymentDetails.recurringDate, 'yyyy-MM-dd'),
      payment_source_type: '3',
      device_info: JSON.stringify(this.mainService.device_info()),
      patient_address: this.patient_address.value.address,
      patient_zip: this.patient_address.value.zip,
      source_id: String(this.dp_source_id),
      contract_metadata: JSON.stringify(contract_metadata),
      language_preffered: this.patient_address.value.language_preffered,
      skip_authrization: 'true',
      charge_flow: this.charge_flow,
      credit_report_status: this.customerSelection? 1 : 0
    }

    if (this.recurring_source_id == -1) {
      body['bank_recurring_source_id'] = String(-1)
    } else {
      body['recurring_source_id'] = String(this.recurring_source_id)
    }

    if (this.backup_source_id == -1) {
      body['bank_alternate_recurring_source_id'] = '-1';
    } else if (this.backup_source_id) {
      body['alternate_recurring_source_id'] = String(this.backup_source_id);
    } else {
      body['bank_alternate_recurring_source_id'] = '-1';
    }
    
    if (this.modalRef) { this.modalRef.hide(); }
    this.mainService.setLoader(true);
    if (this.paymentLoader) {
      return false;
    } else {
      this.payment_error = '';
      this.paymentLoader = true;
      this.proposal.formApi('post', 'pay_split_pf', body)
        .subscribe((data: any) => {
          this.paymentLoader = false;
          this.mainService.setLoader(false);
          if (data && typeof data == 'string') data = JSON.parse(data);
          if (data.is_error == 1) {
            this.charge_flow = this.charge_flow == 1 ? 2 : 1;
            if (data.flag === 585) {
              this.mainService.saveFinancingError({ payment_intent_id: data.data.client_secret, contract_token: this.contractToken, error_message: (data.override_text || data.err), error_type: "createContract", panel: this.panel });
              this.toaster.message(data.err || data.override_text, 3);
              this.router.navigate(['plans', this.contractToken]);
              return false;
            }
            this.card_payment_tried = data.card_payment_tried;
            if (data.override_text && (data.is_financed || data.is_expired)) {
              this.mainService.saveFinancingError({ payment_intent_id: data.data.client_secret, contract_token: this.contractToken, error_message: (data.override_text || data.err), error_type: "createContract", panel: this.panel });
              this.toaster.message(data.override_text, 3);
              setTimeout(() => {
                this.router.navigate(['plans', this.contractToken]);
              }, 3000);
              return false;
            } else {
              // this.RemoveStripeElement('secondary_card');
              this.mainService.saveFinancingError({ payment_intent_id: data.data.client_secret, contract_token: this.contractToken, error_message: (data.override_text || data.err), error_type: "createContract", panel: this.panel });
              this.payment_error = data.override_text || data.err;
              this.paymentFail.show()
            }
          }

          if (data.is_error == 0 && (data && data.data && data.data.require_customer_action)) {
            this.paymentLoader = true;
            this.mainService.setLoader(true);
            this.mainService.stripe.confirmPayment({
              clientSecret: data.data.client_secret,
              redirect: 'if_required'
            }).then((res) => {
              if (res && res.paymentIntent && res.paymentIntent.id) {
                this.route.queryParams.subscribe((resp: any) => {
                  if (resp && resp.redirect_url && resp.redirect_url.length) {
                    window.location.href = resp.redirect_url + '?request_success=true';
                    return;
                  }
                });
                if (this.selected_dp_card && this.selected_dp_card.payment_source_type == 1) {
                  if (this.dp_source_id == -1) {
                    this.success_message = "Your contract has been created in pending state.\nAfter you verify your micro-deposits and we receive payment from your bank, your contract will be fully active!"
                  } else {
                    this.success_message = "Your contract has been created.\nAfter we receive payment from your bank, your contract will be fully active!"
                  }
                }
                this.contract_code = data.data.contract_code;
                this.goToCustomerDetails();
              } else if (res.error && res.error['message']) {
                this.charge_flow = this.charge_flow == 1 ? 2 : 1;
                this.mainService.saveFinancingError({ payment_intent_id: data.data.client_secret, contract_token: this.contractToken, error_message: res.error['message'], error_type: "createContract", panel: this.panel });
                this.mainService.customPopups(res.error['message'], 1);
              }
              this.paymentLoader = false;
              this.mainService.setLoader(false);
            }).catch((err) => {
              this.charge_flow = this.charge_flow == 1 ? 2 : 1;
              this.paymentLoader = false;
              this.mainService.setLoader(false);
              this.mainService.saveFinancingError({ payment_intent_id: data.data.client_secret, contract_token: this.contractToken, error_message: err, error_type: "createContract", panel: this.panel });
              this.mainService.customPopups(err, 1);
            });
          } else {
            if (data.is_error == 0) {
              this.route.queryParams.subscribe((resp: any) => {
                console.log(resp);
                if (resp && resp.redirect_url && resp.redirect_url.length) {
                  window.location.href = resp.redirect_url + '?request_success=true';
                  return;
                }
              });
              if (this.selected_dp_card && this.selected_dp_card.payment_source_type == 1) {
                if (this.dp_source_id == -1) {
                  this.success_message = "Your contract has been created in pending state.\nAfter you verify your micro-deposits and we receive payment from your bank, your contract will be fully active!"
                } else {
                  this.success_message = "Your contract has been created.\nAfter we receive payment from your bank, your contract will be fully active!"
                }
              }
              this.contract_code = data.contract_code;
              this.goToCustomerDetails();
            } else if (data.is_error == 1) {
              this.charge_flow = this.charge_flow == 1 ? 2 : 1;
              this.mainService.saveFinancingError({ payment_intent_id: data.data.client_secret, contract_token: this.contractToken, error_message: data.err || data.override_text, error_type: "createContract", panel: this.panel });

              this.toaster.message(data.err || data.override_text, 1);
              return false;
            }
          }
        }, (error: any) => {
          // console.log(error);
          this.charge_flow = this.charge_flow == 1 ? 2 : 1;
          this.paymentLoader = false;
          this.mainService.setLoader(false);
          this.mainService.saveFinancingError({ payment_intent_id: "request_token", contract_token: this.contractToken, error_message: error || error.message, error_type: "createContract", panel: this.panel });
          this.toaster.message(error || error.message, 1);
        });
    }
  }

  goToCustomerDetails() {
    // if (this.modalRef) {
    //   this.modalRef.hide();
    // }
    this.opened_step = 5
    // this.confirmPaymentModal.show();
  }
  // gotoThanksPage() {
  //   this.router.navigate(['thanks', this.contractToken]);
  // }
  showElement = false;
  // openAddBankPopup(modal = false, payment_source_type) {
  openAddBankPopup(payment_source_type) {
    this.payment_source_type = payment_source_type;
    // console.log(this.selected_card);
    if (this.selected_card) {
      if (this.mod_step == 1) {
        this.dp_source_id = this.selected_card['source_id'];
      } else if (this.mod_step == 2) {
        this.recurring_source_id = this.selected_card['source_id'];
        if (!this.dp_source_id && this.selected_card['payment_source_type'] != 1) {
          this.dp_source_id = this.selected_card['source_id'];
        }
        if (this.recurring_source_id == this.backup_source_id) {
          this.backup_source_id = null;
        }
        this.selected_recurring_card = this.selected_card;
      } else if (this.mod_step == 3) {
        this.backup_source_id = this.selected_card['source_id'];
      }
      this.addNewPaymentMethodModal.hide();
      this.closeBank();
      this.checkPaymentSources();
    } else {
      this.callIntentApi();
      // this.mainService.createStripeElmentsDynamic('')
      // modal.show();
      // if (this.mainService.stripeElement2PaymentIntent) {
      //   this.mainService.stripeElement2PaymentIntent.mount('#payment-element');
      // }
    }

    // this.plaidService.openPlaidPopup(
    //   {
    //     token: this.contractToken,
    //     type: 6,
    //     patient_id: this.patientData['patient_id']
    //   }
    // )
  }

  callIntentApi(checkValidation = true, addRecurringBtn = false) {
    if (this.bank_addded && this.add_bank_step == 'bank') {
      this.mainService.setLoader(false);
      if (checkValidation) {
        this.mainService.customPopups('Please select the bank or change payment method', 1);
      }
      return;
    }
    const params = {
      contract_patient_token: this.contractToken,
      payment_matrix_type: this.opened_step == 1 ? this.mainService.payment_method_type_selected.PRIMARY : (this.opened_step == 2 ? this.mainService.payment_method_type_selected.RECURRING : this.mainService.payment_method_type_selected.BACKUP),
      payment_source_type: (this.add_bank_step + '').toUpperCase() == 'BANK' ? 1 : 2
    };
    this.mainService.setLoader(true);
    this.proposal.api('post', 'create_payment_intent', this.mainService.urlParams(params)).subscribe(response => {
      if (response.is_error == 0 && response.client_secret) {
        if (response.payment_method_type && response.payment_method_type.length && response.payment_method_type.includes('acss_debit') && !addRecurringBtn) {
          this.mainService.stripe.confirmAcssDebitSetup(
            response.client_secret,
            {
              payment_method: {
                billing_details: {
                  name: response.patient_name,
                  email: response.email,
                },
              },
            }
          ).then(resp => {
            this.mainService.setLoader(false);
            if (resp.setupIntent) {
              const obj = {
                contract_patient_token: this.contractToken,
                setup_id: resp.setupIntent.id,
                payment_source_type: 1,
                contract_id: this.planInfo.contract_id
              };
              this.confirmProposalApi(obj);
            } else {
              this.mainService.customPopups('Please try again later', 1);
            }
          }).catch(err => {
            this.mainService.setLoader(false);
          })
        } else {
          this.showElement = true;
          // this.addNewPaymentMethodModal.hide();
          this.mainService.setLoader(false);
          if(!this.manual_continue) {
            response['patient_address'] = this.patient_address.value.address;
          response['patient_city'] = this.patient_address.controls.city.value;
          response['patient_state'] = this.patient_address.controls.state_code.value;
          response['patient_zip'] = this.patient_address.controls.zip.value;
          if(this.patientData && this.patientData.country_id == 7 && (this.patientData.patient_mobile_country_code != '+61')) {
            this.mainService.currency_data.country_code = 'US';
            response['country_code'] = this.mainService.currency_data.country_code;
          } else {
            response['country_code'] = this.mainService.currency_data.country_code;
          }
          }
          
          this.mainService.createStripeElmentsDynamic(response.client_secret, 0, response)
          // modal.show();
          if (this.mainService.stripeElement2PaymentIntent) {
            setTimeout(() => {
              if (params.payment_source_type != 1) {
                this.mainService.stripeAddressElement.mount('#address-element');
              }
              this.mainService.stripeElement2PaymentIntent.mount('#payment-element');
            }, 200);
          }
        }
      }
    })
  }

  confirmPayment() {
    this.mainService.setLoader(true);
    this.mainService.stripe.confirmSetup({
      elements: this.mainService.stripePaymentIntent,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: environment.request_panel_link + 'pay-now/' + this.contractToken
      },
      redirect: "if_required"
    }).then(resp => {
      if (resp.setupIntent && resp.setupIntent.payment_method) {
        const obj = {
          contract_patient_token: this.contractToken,
          // patient_id: this.patientData['patient_id'],
          setup_id: resp.setupIntent.id,
          payment_source_type: this.add_bank_step == 'bank' ? 1 : 2, // for bank and card
          contract_id: this.planInfo.contract_id
        }
        if (this.add_bank_step == 'bank') {
          obj['bank_status'] = 'succeeded';
        }
        this.confirmProposalApi(obj);
      } else {
        this.mainService.saveFinancingError({ payment_intent_id: "dummyIntent", contract_token: this.contractToken, error_message: resp.error['message'], error_type: "payNow", panel: this.panel });
        this.mainService.setLoader(false);
      }
    });
  }

  confirmProposalApi(obj) {
    this.proposal.api('post', 'add_payment_source', this.mainService.urlParams(obj)).subscribe(response => {
      this.mainService.setLoader(false);
      if (response.is_error) {
        // this.mainService.customPopups('Something went wrong, please try again later', 1);
        this.mainService.customPopups(response.err || response.override_text, 1);
        this.showElement = false;
        this.callIntentApi();
        // this.addBankModal.hide();
        // this.openModal_1(this.mod_step, this.addNewPaymentMethodModal);
      } else {
        if (response && typeof response == 'string') {
          response = JSON.parse(response);
        }
        if (this.add_bank_step == 'bank' && obj.payment_source_type == 1) {
          this.bank_addded = true;
        }
        if (this.mod_step == 1) {
          this.dp_source_id = response.source_id;
        } else if (this.mod_step == 2) {
          this.recurring_source_id = response.source_id;
          if (!this.dp_source_id && response.payment_source_type != 1) {
            this.dp_source_id = response.source_id;
          }
        } else if (this.mod_step == 3) {
          this.backup_source_id = response.source_id;
        }
        this.patientData['payment_sources'] = [...[{ source_id: response.source_id, brand: response.brand, last4: response.last4, fingerprint: response.fingerprint, payment_source_type: response.payment_source_type, payment_source: this.add_bank_step == 'card' ? '' : 'Bank'}], ...this.patientData['payment_sources']]
        const matched_source = this.patientData['payment_sources'].filter(source => source.source_id == this.recurring_source_id);
        if (matched_source && matched_source[0]) {
          this.selected_recurring_card = matched_source[0];
        }
        this.new_bank_added = 1;
        this.checkPaymentSources();
        // this.addBankModal.hide();
        this.addNewPaymentMethodModal.hide();
        this.showElement = false;
      }
    })
  }

  // reAuthenticatePlaid() {
  //   this.plaidService.openPlaidPopup(
  //     {
  //       token: this.contractToken,
  //       type: 6,
  //       patient_id: this.patientData['patient_id'],
  //       plaid_access_token: this.patientData['plaid_access_token']
  //     }
  //   )
  // }
  ChangeArrows(step) {
    // for-adding-class
    if (step > 0) {
      this.mainService.closePayBtn = true;
    } else {
      console.log(this.opened_step, 'enter-2');
      this.mainService.closePayBtn = false;
    }
    // for-adding-class-end
    if (step == 1) {
      this.mainService.current_step = 2;
      if (this.opened_step == 1) {
        this.opened_step = 2;
      } else {
        this.payment_step = 1;
        this.opened_step = 2;
      }
    } else if (step == 2) {
      if (this.mod_step == 2) {
        this.opened_step = -1;
      } else {
        this.payment_step = 1;
        this.nextStep();
      }
    } else if (step == 3) {
      if (this.opened_step == 3) {
        this.opened_step = -1;
      } else {
        this.payment_step = 2;
        this.nextStep();
      }
    }
  }

  stopSocket() {
    if (this.mainService.socket && this.mainService.socket.connected) {
      this.mainService.socket.connect();
    }
    this.mainService.socket.emit(this.mainService.socketIDS.STOP_LOADING, {doctor_id: this.planInfo.doctor_id, link_id: this.contractToken, contract_created: false});
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): any {
    if (this.scanner_continue) {
      this.stopSocket();
    }
    // let index = 1;
    // do {
    //   index += 1;
    //   console.log(index);
    // }
    // while (index < 30)
    if (this.showConfirmationDialog) {
      $event.returnValue = 'Are you sure you want to leave this page?';
    }
  }
  detect(eve?) {
    if (eve && (!this.redirect_url || (this.redirect_url && !this.redirect_url.length))) {
      this.showConfirmationDialog = true;
    }
  }
  checkAddCard(modal) {
    if (Number(this.mod_step) == 5) {
      if (this.add_card_source_id) {
        this.dp_source_id = this.add_card_source_id;
        modal.hide();
        this.ChangeArrows(2);
      } else {
        this.GetStripeToken('add_new_card1');
      }
    } else if (Number(this.mod_step == 3)) {
      if (this.add_card_source_id) {
        this.recurring_source_id = this.add_card_source_id;
        modal.hide();
        this.ChangeArrows(3);
      } else {
        this.GetStripeToken('add_new_card1');
      }
    } else if (Number(this.mod_step == 4)) {
      if (this.add_card_source_id) {
        this.backup_source_id = this.add_card_source_id;
        this.nextStep(modal);
      } else {
        this.GetStripeToken('add_new_card1');
      }
    }
  }

  CardFocussed() {
    this.add_card_source_id = null;
    if (this.mod_step == 1) {
      this.dp_source_id = null;
    } else if (this.mod_step == 2) {
      this.recurring_source_id = null;
    } else if (this.mod_step == 3) {
      this.backup_source_id = null;
    }
  }
  BackAddCard(modal) {
    this.add_card_source_id = null;
    if (this.mod_step == 1) {
      this.dp_source_id = null;
    } else if (this.mod_step == 2) {
      this.recurring_source_id = null;
    } else if (this.mod_step == 3) {
      this.backup_source_id = null;
    }
    modal.hide();
  }

  goToLink(url: string) {
    if (!url.includes('http')) {
      url = "http://" + url
    }
    window.open(url, "_blank");
  }

  calculateTotalPayableAmount(amt1, amt2) {
    return Number(amt1) + Number(amt2) + (this.customerSelection?this.planInfo?.credit_report_amount:0);
     
  }

  getMyCard(source_id?, source?) {
    let card;
    if (this.patientData && this.patientData[source]) {
      this.patientData[source].forEach((item) => {
        if (Number(item.source_id) === Number(source_id)) {
          card = item;
        }
        return card;
      });
    }
    return card;
  }

  // getMyCard(source_id, source) {
  //   let card;
  //   let demo = {
  //     "exp_month": null,
  //     "exp_year": null,
  //     "funding": "0",
  //     "bank_status": "",
  //     "type": null,
  //     "source_id": 0,
  //     "doctor_id": 0,
  //     "patient_id": 0,
  //     "token": "",
  //     "payment_source_type": 0,
  //     "brand": "",
  //     "last4": "",
  //     "verified_date": "",
  //     "is_deleted": 0,
  //     "fingerprint": "",
  //     "last_error": null,
  //     "default": 0,
  //     "payment_source": "Bank",
  //     "stripe_flat_fee": 0,
  //     "stripe_percentage_fee": 0,
  //     "maximum_limit": 0
  //   }
  //   if (this.patientData && this.patientData[source]) {
  //     this.patientData[source].forEach((item) => {
  //       if (Number(item.source_id) === Number(source_id)) {
  //         card = item;
  //       }
  //       return card || demo;
  //     });
  //   }
  //   return card || demo;
  // }

  openModal_1(step, modal) {
    this.mod_step = Number(step);
    // this.validValue = false;
    console.log(this.mod_step);
    // if (this.mod_step == 2 && this.planInfo.selected_payment_matrix.recurring_type == 1) {
    //   this.add_bank_step = 'bank';
    // } else if (this.mod_step == 3 && this.planInfo.selected_payment_matrix.backup_type == 1) {
    //   this.add_bank_step = 'bank';
    // } else if (this.mod_step == 1 && this.planInfo.selected_payment_matrix.primary_type == 1) {
    //   this.add_bank_step = 'bank';
    // } else {
    //   this.gettingCard ? this.add_bank_step = 'card' : this.add_bank_step = 'bank';
    // }
    if (!this.manual_continue){
      if (this.mod_step == 2 && (this.planInfo.selected_payment_matrix.recurring_type == 1 || this.planInfo.selected_payment_matrix.recurring_type == 3)) {
        this.add_bank_step = 'bank';
      } else if (this.mod_step == 3 && (this.planInfo.selected_payment_matrix.backup_type == 1 || this.planInfo.selected_payment_matrix.recurring_type == 3) && !(this.getMyCard(this.recurring_source_id, 'recurring_sources') && this.getMyCard(this.recurring_source_id, 'recurring_sources').payment_source == 'Bank')) {
        this.add_bank_step = 'bank';
      } else if (this.mod_step == 1 && (this.planInfo.selected_payment_matrix.primary_type == 1 || this.planInfo.selected_payment_matrix.recurring_type == 3)) {
        this.add_bank_step = 'card';
      } else {
        this.add_bank_step = 'card';
      }
    } else {
      this.add_bank_step = 'card';
    }
    // this.validValue = false;
    if (this.mod_step == 3) {
      this.patientData_backup = this.patientData && this.patientData['backup_sources'] && this.patientData['backup_sources'].filter(source => source.card_type);
          // this.patientData_backup = this.patientData_backup && this.patientData_backup.filter(source => source.card_type.includes("BACKUP_CARD"));
      if (this.add_bank_step == 'bank' && !this.bank_addded) {
        this.callIntentApi();
        this.validValue = true;
      }
      if (this.add_bank_step == 'bank' && this.bank_addded) {
        this.validValue = true;
      }
      if (this.add_bank_step == 'card' &&
        (this.patientData && this.patientData.recurring_sources && this.patientData.recurring_sources.length > 0
          && this.patientData && this.patientData.backup_sources && this.patientData.backup_sources.length > 0
          && this.patientData && this.patientData.primary_sources && this.patientData.primary_sources.length > 0)) {
        this.validValue = true;
      }
      // if (this.gettingCard) {
      //   if (this.patientData_recure && this.patientData_recure.length > 0) {
      //     this.validValue = true;
      //   } else {
      //     this.callIntentApi();
      //   }
      // }
      this.backUpCard = true;
    } else {
      this.backUpCard = false;
    }

    if (this.mod_step == 1) {
      if (this.add_bank_step == 'bank' && !this.bank_addded) {
        this.callIntentApi();
        this.validValue = true;
      }
      if (this.add_bank_step == 'bank' && this.bank_addded) {
        this.validValue = true;
      }
      if (this.add_bank_step == 'card') {
        this.validValue = true;
      }
      this.todayPaymentCard = true;
    } else {
      this.todayPaymentCard = false;
    }

    if (this.mod_step == 2) {
      this.patientData_recure = this.patientData && this.patientData['recurring_sources'] && this.patientData['recurring_sources'].filter(source => source && source.card_type);
          // this.patientData_recure = this.patientData_recure && this.patientData_recure.filter(source => source.card_type.includes("RECURRING_CARD"));
      if (this.add_bank_step == 'bank' && !this.bank_addded) {
        const automation_business = this.patientData && this.patientData.total_automation_business
        if(!automation_business.includes(String(this.planInfo && this.planInfo.doctor_id))){
          this.callIntentApi(true, true);
        }
        this.validValue = true;
      }
      if (this.add_bank_step == 'bank' && this.bank_addded) {
        this.validValue = true;
      }
      // if (!this.patientData_backup && (this.patientData_backup && !this.patientData_backup.length) && !this.checkBankAllowed()) {
      //   this.existing(this.buttonSelectedType.cardTab);
      //   this.validValue = true;
      // }
      this.recurringCard = true;
    } else {
      this.recurringCard = false;
    }
    this.selected_card = '';
    setTimeout(() => {
      this.dataEnter = true;
    }, 200);

    if (modal) {
      modal.show();
      setTimeout(() => {
        // this.callIntentApi();
        this.selected_card = '';
      }, 500);
      this.setNavigationData();
    }
  }

  redirectBack() {
    if (this.manual_continue) {
      window.location.href = environment.business_url + '?manual_close=manual_close';
    }
    if (this.scanner_continue) {
      this.mainService.closeModalSteps.next(false);
      this.router.navigate(['/remind-later/' + this.contractToken], { queryParams: { reason: 'true' } });
    }
  }

  checkBankAllowed() {
    if (this.planInfo && this.patientData && this.patientData['show_ach'] == 1 && ((this.mod_step == 2 && (this.planInfo.selected_payment_matrix && (this.planInfo.selected_payment_matrix.recurring_type == 1 || this.planInfo.selected_payment_matrix.recurring_type == 3))) ||
      (this.mod_step == 3 && this.planInfo.selected_payment_matrix && (this.planInfo.selected_payment_matrix.backup_type == 1 || this.planInfo.selected_payment_matrix.backup_type == 3))
      || (this.mod_step == 1 && this.planInfo.selected_payment_matrix && (this.planInfo.selected_payment_matrix.primary_type == 1 || (this.planInfo.selected_payment_matrix.primary_type == 3))))) {
      return true;
    } else {
      return false;
    }
  }

  existing(data) {
    // if (this.selectTypeButtonCardBank == data) {
    //   return;
    // }
    // this.selectTypeButtonCardBank = data;
    if (data == this.buttonSelectedType.existing) {
      // this.opened_step = 2;
      this.validValue = true;
      this.showElement = false;
      this.selected_card = '';
    }
    if (data == this.buttonSelectedType.bank) {
      this.selected_card = '';
      if (this.add_bank_step == 'bank') {
        if (this.bank_addded) {
          return this.validValue = true;
        }
        this.callIntentApi(true, true);
        this.validValue = true;
      } else {
        this.callIntentApi();
        this.validValue = false;
      }
    }
    if (data == this.buttonSelectedType.cardTab) {
      if ((this.patientData && this.patientData.recurring_sources && this.patientData.recurring_sources.length == 0
        && this.patientData && this.patientData.backup_sources && this.patientData.backup_sources.length == 0
        && this.patientData && this.patientData.primary_sources && this.patientData.primary_sources.length == 0)) {
        this.callIntentApi();
        this.validValue = false;
      }
      this.validValue = true;
    }

    console.log(data);
  }


  saveOptions(card?, card_selected?) {
    if (this.add_bank_step == 'bank' && !this.selected_card) {
      this.mainService.customPopups('Please add valid Payment Method', 1);
      return;
    }
    if (!this.selected_card && (this.mod_step === 1 || this.mod_step === 2 || this.mod_step === 3)) {
      this.GetStripeToken(card);
      return;
    }
    this.saveCard();
  }


  saveCard() {
    if (this.selected_card) {
      if (this.selected_card.funding) {
        if (this.mainService.featureList && this.mainService.featureList.length) {
          const featureFilter = this.mainService.featureList.find(item => item.feature_enum === 'PAYMENTMETHOD');
          const getFeature = featureFilter ? JSON.parse(JSON.stringify(featureFilter)) : {};
          if (getFeature && getFeature.payment_method) {
            getFeature.payment_method = JSON.parse(getFeature.payment_method);
            // tslint:disable-next-line:max-line-length
            if ((this.selected_card.payment_source + '').toLocaleUpperCase() != 'BANK' && !getFeature.payment_method.includes((this.selected_card.funding + '').toLocaleUpperCase())) {
              this.mainService.setLoader(false);
              this.toaster.message(`Payment type ${this.selected_card.funding} is not supported as per your business plan`, 3);
              return false;
            }
          } else {
            // tslint:disable-next-line:max-line-length
            if ((this.selected_card.payment_source + '').toLocaleUpperCase() === 'BANK' && !getFeature.payment_method.includes(('ACH').toLocaleUpperCase())) {
              this.mainService.setLoader(false);
              this.toaster.message(`Payment type BANK is not supported as per your business plan`, 3);
              return false;
            } else {
              return true;
            }
          }
        }
      }
      if (Number(this.mod_step) === 2) {
        this.recurring_source_id = this.selected_card.source_id;
        this.selected_recurring_card = this.selected_card;
        if (this.selected_backup_card && this.selected_backup_card.fingerprint && (this.selected_backup_card.fingerprint == this.selected_card.fingerprint)) {
          this.selected_backup_card = {};
          this.backup_source_id = 0
        }

      } else if (Number(this.mod_step) === 3) {
        this.backup_source_id = this.selected_card.source_id;
        this.selected_backup_card = this.selected_card;

      } else if (Number(this.mod_step) === 1) {
        this.dp_source_id = this.selected_card.source_id;
        this.selected_dp_card = this.selected_card;
      }
      if ([1].includes(this.mod_step)) {
        this.primaryCardChanged(this.selected_card.payment_source_type, this.selected_card.source_id)
        // this.calculateTotalPayable();
      }
      this.selected_card = null;
      this.checkPaymentSources();
      this.setNavigationData();
      this.addNewPaymentMethodModal.hide();
    }
  }

  changeScreen() {
    // console.log(this.opened_step, 'this.opened_step');

    if ((this.opened_step === 2)) {
      this.mainService.closePayBtn = false;
      // this.mainService.closeBtnHanling = true;
      // console.log(this.mainService.closePayBtn, 'on-change-screen');
    }

    if (this.opened_step === 0) {
      this.backToPayment()
      // window.history.back();
      return;
    } else if (this.opened_step === 2) {
      this.opened_step = 0;
    } else {
      this.opened_step = this.opened_step - 1;
    }
    this.mainService.current_step = this.mainService.current_step - 1;
  }

  switchForm() {
    if (this.opened_step === 3) {
      if (!this.recurring_source_id) {
        this.toaster.message('Please select/add a recurring payment source.', 3);
        return;
      }
      if (this.recurring_source_id && this.backup_source_id && this.getMyCard(this.recurring_source_id, 'recurring_sources').fingerprint === this.getMyCard(this.backup_source_id, 'backup_sources').fingerprint) {
        this.toaster.message('Recurring payment method and backup payment method cannot be same', 3);
        return false;
      }
      // if (this.planInfo.selected_payment_matrix.backup_required === 1 && !this.backup_source_id) {
      //   this.toaster.message('warning', 'Please add/select a payment method for the backup payment');
      //   return;
      // }
      // if (!this.paymentDetails.recurringDate) {
      //   this.toaster.message('warning', 'Please choose a valid recurring payment source.');
      //   return;
      // }
      // if (this.split_request_data[0].payment_matrix_array[0].backup_required && !this.backup_source_id) {
      //   this.toaster.message('warning', 'Please add Backup Payment Method.');
      //   return false;
      // }



    if(!this.customerSelection && this.creditReportOption && this.plans?.doctor_country_currency_info?.country?.country_id == 1){
          this.openCreditDialog()
        }else{
          let tillaData = JSON.parse(localStorage.getItem('iframe_tila_data')||'')
              tillaData.credit_report_status = this.customerSelection?1:0
              localStorage.setItem(
            "iframe_tila_data",
            JSON.stringify(tillaData)
          );
          this.mainService.current_step = 4;
          this.opened_step = 4;
        }
      }
    }
  changePaymentMethodFailed(modal?) {
    if (this.payment_error.includes('recurring')) {
      this.mod_step = 2;
    }
    if (this.payment_error.includes('insufficient funds')) {
      this.mod_step = 1;
    }
    if (!this.payment_error.includes('recurring')) {
      this.mod_step = 1;
    }
    if (this.payment_error) {
      this.mod_step = 1;
    }
    modal.hide();
    this.openModal_1(this.mod_step, this.addNewPaymentMethodModal);
    // this.addNewPaymentMethodModal.show();
  }

  toggle() {
    this.add_button = !this.add_button
  }

  onShowPicker(event) {
    const dayHoverHandler = event.dayHoverHandler;
    const hoverWrapper = (hoverEvent) => {
      const { cell, isHovered } = hoverEvent;

      if ((isHovered &&
        !!navigator.platform &&
        /iPad|iPhone|iPod/.test(navigator.platform)) &&
        'ontouchstart' in window
      ) {
        (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
      }

      return dayHoverHandler(hoverEvent);
    };
    event.dayHoverHandler = hoverWrapper;
  }

  getNumber(d) {
    return Number(d);
  }

  canGoBack() {
    if (window['navigation'] && window['navigation'].canGoBack) {
      return window['navigation'].canGoBack;
    } else {
      return false;
    }
  }

  paymentMethodValidation(type, funding_type) {
    if (this.mainService.featureList && this.mainService.featureList.length) {
      const featureFilter = this.mainService.featureList.find(item => item.feature_enum === 'PAYMENTMETHOD');
      const getFeature = featureFilter ? JSON.parse(JSON.stringify(featureFilter)) : {};
      if (getFeature && getFeature.payment_method) {
        getFeature.payment_method = JSON.parse(getFeature.payment_method);
        // tslint:disable-next-line:max-line-length
        if ((type + '').toLocaleUpperCase() != 'BANK' && funding_type && !getFeature.payment_method.includes((funding_type + '').toLocaleUpperCase())) {
          this.mainService.setLoader(false);
          this.toaster.message(`Payment type ${funding_type} is not supported as per your business plan`, 3);
          return false;
        } else {
          // tslint:disable-next-line:max-line-length
          if ((type + '').toLocaleUpperCase() === 'BANK' && !getFeature.payment_method.includes(('ACH').toLocaleUpperCase())) {
            this.mainService.setLoader(false);
            this.toaster.message(`Payment type BANK is not supported as per your business plan`, 3);
            return false;
          } else {
            return true;
          }
        }
      } else {
        this.mainService.setLoader(false);
        this.toaster.message(`Payment type is not supported as per your business plan.`, 3);
        return false;
      }
    }
  }

  changeFlag(i) {
    this.flag_code = (this.mainService.country_data[i]['country_code'] + '').toLocaleLowerCase();
  }
  showStripefields() {
    this.add_bank_step = 'card';
    this.selected_card = ''
    this.stripeFieldsshow = true;
  }
  checkValue(e: any, i) {
    // this.showElement = false;
    this.stripeFieldsshow = false;
    if (i == 3) {
      this.addNewPaymentMethodModal.hide();
    }
  }
  closeBank() {
    this.addNewPaymentMethodModal.hide();
    setTimeout(() => {
      this.validValue = false;
      this.dataEnter = false;
      this.showElement = false;
      this.stripeFieldsshow = false;
    }, 800);
  }
  downloadContract() {
    // this.proposal.downloadContract(this.payRecurring.payToken, this.contractToken, this.payRecurring.pay_recurring);
    const params = {
      pay_recurring_token: this.payRecurring.payToken,
      contract_patient_token: this.contractToken,
      device_info: JSON.stringify(this.mainService.device_info())
    };
    if (this.payRecurring.pay_recurring == 1) {
      delete params.contract_patient_token;
    } else {
      delete params.pay_recurring_token;
    }
    this.mainService.setLoader(true);
    this.proposal.downloadApi('download_contract_pdf', params, 0)
      .subscribe((data: any) => {
        console.log(data);
        this.mainService.setLoader(false);
      }, (error: any) => {
        console.log(error);
        this.mainService.setLoader(false);
      });
  }

  openTila() {
    this.showModalTila = true;
    this.tilaModal.show()
  }
  openHipaa() {
    this.showModalHipaa = true;
    this.hipaaModal.show()
  }
  isIOS() {
    const iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ];

    if (navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }
  openPanel() {
    let url = '';
    if (this.verified == 1) {
      url = 'verify?link_id=' + this.contractToken;
    }
    console.log(environment.customer_panel_link);
    window.open(environment.customer_panel_link + url, '_blank');
  }
  continueLogin() {
    if ((/(android)/i.test(navigator.userAgent) || this.isIOS()) && this.paymentModal) {
      this.paymentModal.show();
    } else {
      this.openPanel();
    }
  }
  checkMobVal() {
    if (!new RegExp(this.mobile_pattern).test(this.patient_address.controls.patient_mobile_country_code.value + this.patient_address.value.patient_mobile)) {
      this.showMobError = true
    } else{
      this.showMobError = false;
    }
  }

  backToPayment() {
    this.mainService.current_step = 2;
    this.router.navigate([`/plans/${this.contractToken}`]);
  }
  checkSSn() {
    const invalid_ssn = ['002281852', '042103580', '062360749', '078051120', '095073645', '128036045', '135016629', '141186941', '165167999', '165187999', '165207999', '212099999', '165227999', '306302348', '165247999', '189092294', '308125070', '212097694', '549241889', '468288779'];
    if (this.mainService.currency_data.country_code == 'US') {
      if (!this.mainService.validateSSN(this.patient_address && this.patient_address.value && this.patient_address.value.patient_ssn ? this.patient_address.value.patient_ssn : this.patientData['patient_ssn'])) {
        this.errorMsg = 'Please enter a valid ' + this.mainService.document_label;
        this.showvalidation = true;
        // this.toaster.message('warning', 'Please enter valid SSN', '');
        return;
      }
    } else {
      if (this.showSSNfields && this.patient_address && !this.patient_address.controls.patient_ssn.disabled && (!this.patient_address.value.patient_ssn || Number(String(this.patient_address.value.patient_ssn).trim().length) === 0 || Number(String(this.patient_address.value.patient_ssn).trim().length) < this.mainService.minDocumentIdLength || Number(String(this.patient_address.value.patient_ssn).trim().length) > this.mainService.maxDocumentIdLength || invalid_ssn.includes(String(this.patient_address.value.patient_ssn).trim()))) {
        // this.toaster.message('warning', 'Please enter a valid ' + this.mainService.document_label, '');
        this.errorMsg = 'Please enter a valid ' + this.mainService.document_label;
        this.showvalidation = true;
        return;
      }
    }
    this.errorMsg = '';
    this.showvalidation = false;
  }

  ngOnDestroy() {
    if (this.planInfo && this.planInfo.doctor_id && this.routeStep) {
      this.mainService.socket.emit(this.mainService.socketIDS.STOP_LOADING, {doctor_id: this.planInfo.doctor_id});
    }
  }

  getParentDivWidth() {
    return document.getElementById('canvasDiv').offsetWidth;
  }

  australiaChange(val) {
    this.mainService.country_data$.subscribe(data => {
      if (data && data.length) {
        this.mobile_validation = data.filter(item => val == item.mobile_code)
        this.updateMasking(this.mobile_validation && this.mobile_validation[0] && this.mobile_validation[0].country_phone_format);
      }
    })
  }

  mapRecurringAmout(value: boolean, _index: number) {
    const feeInCents = this.planInfo.credit_report_amount * 100;
    const plan = this.planInfo.selected_plan;
    const currentRecurringAmountInCents = Math.round(plan.recurring_amount_with_credit_fee * 100);
    const newRecurringAmountInCents = value ? currentRecurringAmountInCents + feeInCents : currentRecurringAmountInCents - feeInCents;
    const newRecurringAmount = newRecurringAmountInCents / 100;
    this.animateCounter(currentRecurringAmountInCents, newRecurringAmountInCents, plan, 'recurring_amount_with_credit_fee');
    plan.creditReportOption = value;
  }

  private animateCounter(startValue: number, endValue: number, plan: any, prop: string, duration: number = 50) {
    this.animationStart = true
    const startTime = performance.now();
    const updateCount = (timestamp: number) => {
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentValue = startValue + (endValue - startValue) * progress;
      plan[prop] = (currentValue / 100).toFixed(2);
      if (progress < 1) {
        requestAnimationFrame(updateCount);
      } else {
        plan[prop] = (endValue / 100).toFixed(2);
      }
    };
    requestAnimationFrame(updateCount);
    this.animationStart = false
  }

  toggleCreditOption(index: number) {
    this.customerSelection = !this.customerSelection
    const plan = this.planInfo.selected_plan;
    const newValue = !plan.creditReportOption;
    this.mapRecurringAmout(newValue, index);
  }


  openCreditDialog(){
    this.dialog.open(CreditReportConfirmationComponent, {
          width: '500px',
          panelClass:'confirmationPopup',
          disableClose:true
        }).afterClosed().subscribe(result => {
          if(result){
            if(result?.selection){
              this.customerSelection = true
              let tillaData = JSON.parse(localStorage.getItem('iframe_tila_data')||'')
              tillaData.credit_report_status = this.customerSelection?1:0
              localStorage.setItem(
            "iframe_tila_data",
            JSON.stringify(tillaData)
          );
              this.mainService.current_step = 4;
              this.opened_step = 4;



            }
            else{
              this.mainService.current_step = 4;
              this.opened_step = 4;
            }
          }else{

          }
        });
  }













}
